/* Clarity engine */
export const Clarity = function() {
  this.startTime = 0;
  this.takeTime = 0;
  this.pausedTime = 0;
  this.alert_errors = false;
  this.log_info = true;
  this.tile_size = 16;
  this.limit_viewport = false;
  this.jump_switch = 0;
  this.showDanger = false;
  this.paused = false;

  this.viewport = {
    x: 200,
    y: 300
  };

  this.camera = {
    x: 0,
    y: 0
  };

  this.key = {
    left: false,
    right: false,
    up: false
  };

  this.player = {
    loc: {
      // 玩家位置（第几个tile）
      x: 0,
      y: 0
    },

    vel: {
      // 速度
      x: 0,
      y: 0
    },

    can_jump: true
  };

  window.onkeydown = this.keydown.bind(this);
  window.onkeyup = this.keyup.bind(this);
};
Clarity.prototype.error = function(message) {
  if (this.alert_errors) alert(message);
  if (this.log_info) console.log(message);
};

Clarity.prototype.log = function(message) {
  if (this.log_info) console.log(message);
};

Clarity.prototype.set_viewport = function(x, y) {
  this.viewport.x = x;
  this.viewport.y = y;
};

Clarity.prototype.keydown = function(e) {
  if (this.paused) return;
  var _this = this;
  switch (e.keyCode) {
    case 37:
      _this.key.left = true;
      if (_this.player_image !== _this.left_image)
        _this.player_image = _this.left_image;
      break;
    case 38:
      _this.key.up = true;
      break;
    case 39:
      _this.key.right = true;
      if (_this.player_image !== _this.right_image)
        _this.player_image = _this.right_image;
      break;
  }
};

Clarity.prototype.keyup = function(e) {
  var _this = this;

  switch (e.keyCode) {
    case 37:
      _this.key.left = false;
      break;
    case 38:
      _this.key.up = false;
      break;
    case 39:
      _this.key.right = false;
      break;
  }
};

Clarity.prototype.panmove = function(e) {
  if (e.indexOf(37) > -1) this.key.left = true;
  if (e.indexOf(38) > -1) this.key.up = true;
  if (e.indexOf(39) > -1) this.key.right = true;
};

Clarity.prototype.panend = function(e) {
  this.key.left = false;
  this.key.up = false;
  this.key.right = false;
};

Clarity.prototype.load_map = function(map) {
  this.startTime = new Date().getTime();
  this.takeTime = 0;
  if (
    typeof map === "undefined" ||
    typeof map.data === "undefined" ||
    typeof map.keys === "undefined"
  ) {
    this.error("Error: Invalid map data!");

    return false;
  }

  this.current_map = map;

  this.current_map.background = map.background || "#1e264a";
  this.current_map.gravity = map.gravity || { x: 0, y: 0.3 };
  this.tile_size = map.tile_size || 16;
  this.left_image = map.left_image;
  this.right_image = map.right_image;
  this.player_image = map.right_image;
  this.vue = map.vue;
  var _this = this;

  this.current_map.width = 0;
  this.current_map.height = 0;

  map.keys.forEach(function(key) {
    map.data.forEach(function(row, y) {
      _this.current_map.height = Math.max(_this.current_map.height, y);

      row.forEach(function(tile, x) {
        _this.current_map.width = Math.max(_this.current_map.width, x);

        if (tile == key.id) _this.current_map.data[y][x] = key;
      });
    });
  });

  this.current_map.width_p = this.current_map.width * this.tile_size;
  this.current_map.height_p = this.current_map.height * this.tile_size;

  this.player.loc.x = map.player.x * this.tile_size || 0; // 玩家元素位置x
  this.player.loc.y = map.player.y * this.tile_size || 0; // 玩家元素位置y
  this.player.colour = map.player.colour || "#000";

  this.key.left = false;
  this.key.up = false;
  this.key.right = false;

  this.camera = {
    x: 0,
    y: 0
  };

  this.player.vel = {
    x: 0,
    y: 0
  };

  this.log("Successfully loaded map data.");

  return true;
};

Clarity.prototype.get_tile = function(x, y) {
  return this.current_map.data[y] && this.current_map.data[y][x]
    ? this.current_map.data[y][x]
    : 0;
};

Clarity.prototype.draw_tile = function(x, y, tile, context) {
  if (!tile || (!tile.colour && !tile.image)) return;
  if (tile.image) {
    context.drawImage(tile.image, x, y, this.tile_size, this.tile_size);
  } else if (tile.colour) {
    context.fillStyle = tile.colour;
    context.fillRect(x, y, this.tile_size, this.tile_size);
  }
};

Clarity.prototype.draw_map = function(context, fore) {
  for (var y = 0; y < this.current_map.data.length; y++) {
    for (var x = 0; x < this.current_map.data[y].length; x++) {
      if (
        (!fore && !this.current_map.data[y][x].fore) ||
        (fore && this.current_map.data[y][x].fore)
      ) {
        var t_x = x * this.tile_size - this.camera.x;
        var t_y = y * this.tile_size - this.camera.y;

        if (
          t_x < -this.tile_size ||
          t_y < -this.tile_size ||
          t_x > this.viewport.x ||
          t_y > this.viewport.y
        )
          continue;

        this.draw_tile(t_x, t_y, this.current_map.data[y][x], context);
      }
    }
  }

  if (!fore) this.draw_map(context, true);
};

Clarity.prototype.move_player = function() {
  if (this.paused) return;
  var tX = this.player.loc.x + this.player.vel.x;
  var tY = this.player.loc.y + this.player.vel.y;

  var offset = Math.round(this.tile_size / 2 - 1);

  var tile = this.get_tile(
    Math.round(this.player.loc.x / this.tile_size),
    Math.round(this.player.loc.y / this.tile_size)
  );

  // this.showDanger
  this.handle_danger_tile(
    Math.round(this.player.loc.x / this.tile_size),
    Math.round(this.player.loc.y / this.tile_size)
  );

  if (tile.gravity) {
    this.player.vel.x += tile.gravity.x;
    this.player.vel.y += tile.gravity.y;
  } else {
    this.player.vel.x += this.current_map.gravity.x;
    this.player.vel.y += this.current_map.gravity.y;
  }

  if (tile.friction) {
    this.player.vel.x *= tile.friction.x;
    this.player.vel.y *= tile.friction.y;
  }

  var t_y_up = Math.floor(tY / this.tile_size);
  var t_y_down = Math.ceil(tY / this.tile_size);
  var y_near1 = Math.round((this.player.loc.y - offset) / this.tile_size);
  var y_near2 = Math.round((this.player.loc.y + offset) / this.tile_size);

  var t_x_left = Math.floor(tX / this.tile_size);
  var t_x_right = Math.ceil(tX / this.tile_size);
  var x_near1 = Math.round((this.player.loc.x - offset) / this.tile_size);
  var x_near2 = Math.round((this.player.loc.x + offset) / this.tile_size);

  var top1 = this.get_tile(x_near1, t_y_up);
  var top2 = this.get_tile(x_near2, t_y_up);
  var bottom1 = this.get_tile(x_near1, t_y_down);
  var bottom2 = this.get_tile(x_near2, t_y_down);
  var left1 = this.get_tile(t_x_left, y_near1);
  var left2 = this.get_tile(t_x_left, y_near2);
  var right1 = this.get_tile(t_x_right, y_near1);
  var right2 = this.get_tile(t_x_right, y_near2);

  // if (tile.jump && this.jump_switch > 15) {
  if (tile.jump && this.jump_switch > 15) {
    this.player.can_jump = true;

    this.jump_switch = 0;
  } else this.jump_switch++;

  this.player.vel.x = Math.min(
    Math.max(this.player.vel.x, -this.current_map.vel_limit.x),
    this.current_map.vel_limit.x
  );
  this.player.vel.y = Math.min(
    Math.max(this.player.vel.y, -this.current_map.vel_limit.y),
    this.current_map.vel_limit.y
  );

  this.player.loc.x += this.player.vel.x;
  this.player.loc.y += this.player.vel.y;

  this.player.vel.x *= 0.9;

  if (left1.solid || left2.solid || right1.solid || right2.solid) {
    /* fix overlap */

    while (
      this.get_tile(Math.floor(this.player.loc.x / this.tile_size), y_near1)
        .solid ||
      this.get_tile(Math.floor(this.player.loc.x / this.tile_size), y_near2)
        .solid
    )
      this.player.loc.x += 0.1;

    while (
      this.get_tile(Math.ceil(this.player.loc.x / this.tile_size), y_near1)
        .solid ||
      this.get_tile(Math.ceil(this.player.loc.x / this.tile_size), y_near2)
        .solid
    )
      this.player.loc.x -= 0.1;

    /* tile bounce */

    var bounce = 0;

    if (left1.solid && left1.bounce > bounce) bounce = left1.bounce;
    if (left2.solid && left2.bounce > bounce) bounce = left2.bounce;
    if (right1.solid && right1.bounce > bounce) bounce = right1.bounce;
    if (right2.solid && right2.bounce > bounce) bounce = right2.bounce;

    this.player.vel.x *= -bounce || 0;
  }

  if (top1.solid || top2.solid || bottom1.solid || bottom2.solid) {
    /* fix overlap */

    while (
      this.get_tile(x_near1, Math.floor(this.player.loc.y / this.tile_size))
        .solid ||
      this.get_tile(x_near2, Math.floor(this.player.loc.y / this.tile_size))
        .solid
    )
      this.player.loc.y += 0.1;

    while (
      this.get_tile(x_near1, Math.ceil(this.player.loc.y / this.tile_size))
        .solid ||
      this.get_tile(x_near2, Math.ceil(this.player.loc.y / this.tile_size))
        .solid
    )
      this.player.loc.y -= 0.1;

    /* tile bounce */

    var bounce = 0;

    if (top1.solid && top1.bounce > bounce) bounce = top1.bounce;
    if (top2.solid && top2.bounce > bounce) bounce = top2.bounce;
    if (bottom1.solid && bottom1.bounce > bounce) bounce = bottom1.bounce;
    if (bottom2.solid && bottom2.bounce > bounce) bounce = bottom2.bounce;

    this.player.vel.y *= -bounce || 0;

    if ((bottom1.solid || bottom2.solid) && !tile.jump) {
      this.player.on_floor = true;
      this.player.can_jump = true;
    }
  }

  // adjust camera

  var c_x = Math.round(this.player.loc.x - this.viewport.x / 2);
  var c_y = Math.round(this.player.loc.y - this.viewport.y / 2);
  var x_dif = Math.abs(c_x - this.camera.x);
  var y_dif = Math.abs(c_y - this.camera.y);

  if (x_dif > 5) {
    var mag = Math.round(Math.max(1, x_dif * 0.1));

    if (c_x != this.camera.x) {
      this.camera.x += c_x > this.camera.x ? mag : -mag;

      if (this.limit_viewport) {
        this.camera.x = Math.min(
          this.current_map.width_p - this.viewport.x + this.tile_size,
          this.camera.x
        );

        this.camera.x = Math.max(0, this.camera.x);
      }
    }
  }

  if (y_dif > 5) {
    var mag = Math.round(Math.max(1, y_dif * 0.1));

    if (c_y != this.camera.y) {
      this.camera.y += c_y > this.camera.y ? mag : -mag;

      if (this.limit_viewport) {
        this.camera.y = Math.min(
          this.current_map.height_p - this.viewport.y + this.tile_size,
          this.camera.y
        );

        this.camera.y = Math.max(0, this.camera.y);
      }
    }
  }

  // 排除气流水流块
  if (
    this.last_tile != tile.id &&
    (this.last_tile !== 4 ||
      this.last_tile !== 3 ||
      tile.id !== 4 ||
      tile.id !== 3) &&
    tile.script
  ) {
    eval(this.current_map.scripts[tile.script]);
  }

  // 弹簧处理
  if ((bottom1.id == 5 || bottom1.id == 2) && bottom1.script) {
    eval(this.current_map.scripts[bottom1.script]);
  }

  // 气流和水流处理
  if ((tile.id === 4 && this.key.up && top1.id === 4 && tile.script)||(tile.id === 3 && top1.id === 3 && tile.script)) {
    eval(this.current_map.scripts[tile.script]);
  }
  // if(tile.id === 4 && !this.key.up&& tile.script0){
  //   eval(this.current_map.scripts[tile.script0]);
  // }

  this.last_tile = tile.id;
};

Clarity.prototype.handle_danger_tile = function(x, y) {
  if (!x || !y) return;
  // for (var i = x; i < x + 3; i++) {
  var i = x + 3;
  for (var j = y - 3; j < y + 3; j++) {
    var tile = this.get_tile(i, j);
    if (tile && tile.script && tile.script === "death") {
      this.player.right = false;
      this.player.up = false;
      this.player.left = false;
      // alert("危险警报！")
      this.security_alert_show();
      // this.showDanger = true;
      break;
    }
  }
};

Clarity.prototype.security_alert_show = function() {
  // var alertDom = document.createElement("div");
  // alertDom.className = "alert";
  // alertDom.style =
  //   "width:240px; height:180px; background:#fff; position:absolute; left:50%; top:50%; transform:tranlate(-50%,-50%);transition:all .4s";
  // alertDom.innerHTML = "<div>危险警报</div>";
  // document.body.appendChild(alertDom);
  // setTimeout(function () {
  //   alertDom.style.opacity = 0;
  //   setTimeout(function () {
  //     document.body.removeChild(alertDom);
  //     // alertDom = null;
  //   }, 400);
  // }, 4000);
};

Clarity.prototype.update_player = function() {
  if (this.key.left) {
    if (this.player.vel.x > -this.current_map.vel_limit.x)
      this.player.vel.x -= this.current_map.movement_speed.left;
  }

  if (this.key.up) {
    if (
      this.player.can_jump &&
      this.player.vel.y > -this.current_map.vel_limit.y
    ) {
      this.player.vel.y -= this.current_map.movement_speed.jump;
      this.player.can_jump = false;
    }
  }

  if (this.key.right) {
    if (this.player.vel.x < this.current_map.vel_limit.x)
      this.player.vel.x += this.current_map.movement_speed.left;
  }

  this.move_player();
};

Clarity.prototype.draw_player = function(context) {
  // context.fillStyle = this.player.colour;

  context.beginPath();

  // context.arc(
  //   this.player.loc.x + this.tile_size / 2 - this.camera.x,
  //   this.player.loc.y + this.tile_size / 2 - this.camera.y,
  //   this.tile_size / 2 - 1,
  //   0,
  //   Math.PI * 2
  // );
  // context.fill();
  var _this = this;
  context.drawImage(
    _this.player_image,
    _this.player.loc.x - _this.camera.x,
    _this.player.loc.y - _this.camera.y,
    _this.tile_size - 1,
    _this.tile_size - 1
  );
};

Clarity.prototype.update = function() {
  this.update_player();
};

Clarity.prototype.draw_take_time = function() {
  if (this.pausedTime > 0) {
    this.takeTime = this.takeTime;
    this.startTime = this.pausedTime - this.takeTime * 1000;
    this.pausedTime = 0;
  } else
    this.takeTime = ((new Date().getTime() - this.startTime) / 1000).toFixed(1);
};

Clarity.prototype.draw = function(context) {
  this.draw_map(context, false);
  this.draw_player(context);
  if (!this.paused) this.draw_take_time();
  else this.pausedTime = new Date().getTime();
};



// WEBPACK FOOTER //
// ./src/util/mazeGame.js